import { ToastContainer } from "react-toastify";
import 'react-toastify/scss/main.scss';

const Toast = () => {
   return (
      <ToastContainer
         className={"toast-custom"}
         position="bottom-right"
         autoClose={3000}
         hideProgressBar
         newestOnTop={false}
         closeOnClick={false}
         rtl={false}
         draggable
         limit={1}
         icon={false}
         closeButton={false}
      />
   )
}

export default Toast;